var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('activity-redirect-to-office'),_c(_vm.currentComponent,_vm._b({tag:"component",on:{"onApplyEMIClick":_vm.showMobileViewActivity}},'component',_vm.welcomeActivityProperties,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }